import 'intl/locale-data/jsonp/en';

const GBP = window.bbGlobal.currentCurrencyIsocode || 'GBP';

function formatPrice(price: number, currency: string, minimumFractionDigits = 0): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits
  });

  return formatter.format(price || 0);
}

export function formatPriceGBP(price: number, minimumFractionDigits = 0): string {
  return formatPrice(parseFloat(price.toFixed(2)), GBP, minimumFractionDigits);
}

export function formatNumber(num: number, minimumFractionDigits = 0): string {
  return num.toLocaleString('en-GB', { minimumFractionDigits });
}

export default formatPrice;
